<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ page.title }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ page.desc }}
      </p>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <!-- MAC表信息 -->
        <block-cntr :btitle="page.blkTitle.mac" style="height: 100%">
          <!-- 按钮 -->
          <div class="form-inline" style="height: 35px">
            <span style="float: left">
              <div class="btn-group open">
                <div @click="loadmac" class="btn" style="padding: 0px">
                  <i class="fa fa-refresh page-tableaction" title="refresh"></i>
                </div>
              </div>
            </span>
            <label style="float: right; display: flex">
              <span class="input-group-addon tablesearch-box">
                <i class="fa fa-search"></i>
              </span>
              <input
                type="search"
                v-model="searchText"
                class="form-control"
                placeholder="search with keywords.."
                style="border-radius: 0px"
              />
            </label>
          </div>
          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th
                  v-for="(value, key) in macTable.title"
                  :key="key"
                  :title="value"
                >
                  <div v-if="key === 'vid'">
                    {{ value }}
                    <label style="position: relative; margin-left: 10px">
                      <i
                        style="position: absolute; top: 3px; left: 5px"
                        class="fa fa-filter"
                      ></i>
                      <input
                        type="text"
                        v-model="searchVid"
                        class="form-control"
                        maxlength="4"
                        style="width: 40%; height: 20px; padding-left: 20px"
                      />
                    </label>
                  </div>
                  <div v-else>
                    {{ value }}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody style="height: 500px">
              <tr v-for="row in macTableFilter" :key="row.mac">
                <td v-for="(value, key) in row" :key="key" :title="value">
                  {{ value }}
                </td>
              </tr>
            </tbody>
          </table>
        </block-cntr>
      </div>
    </div>
    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "./../components/InfoBox.vue"
import { get, post } from "@/utils/http.js"

export default {
  name: "mac",
  components: {
    BlockCntr,
    InfoBox,
  },
  data() {
    return {
      page: en.page.mac,
      macTable: "",
      searchVid: "",
      searchText: "",
      iBox: {},
    }
  },
  created() {
    this.loadmac()
  },
  methods: {
    loadmac() {
      get("mac")
        .then((res) => (this.macTable = res.data))
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
  computed: {
    macTableFilter() {
      var macT = []
      if (this.macTable.data !== undefined)
        this.macTable.data.forEach((element) => {
          if (this.searchVid !== "" && this.searchVid !== element["vid"]) return
          for (const key in element) {
            if (
              this.searchText === "" ||
              element[key].indexOf(this.searchText) !== -1
            ) {
              macT.push(element)
              break
            }
          }
        })
      return macT
    },
  },
}
</script>